import React from "react";
import { graphql } from "gatsby";
import { MDXProvider } from "@mdx-js/react";
import { MDXRenderer } from "gatsby-plugin-mdx";
import { Link } from "gatsby";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";
import "../scss/style.scss";
import AniLink from "gatsby-plugin-transition-link/AniLink";

const shortcodes = { Link }; 
// Provide common components here

export default function PageTemplate({ data: { mdx } }) {
  return (
    <div className="template-blog">
      <article>
        <main>
          <AniLink cover to="/portfolio" style={{marginTop:"20vh"}}>
            <FontAwesomeIcon icon={faArrowLeft}/>
            See all projects
          </AniLink>
          <h1>{mdx.frontmatter.title}</h1>
          <h5>Published by {mdx.frontmatter.author}</h5>
          <MDXProvider components={shortcodes}>
            <MDXRenderer>{mdx.body}</MDXRenderer>
            <p>{mdx.frontmatter.developer}</p>
            <a href={mdx.frontmatter.link} rel="noreferrer"  target="_blank"> See the live site here</a>
          </MDXProvider>
        </main>
      </article>
    </div>
  );
}

export const pageQuery = graphql`
  query BlogPostQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      frontmatter {
        title
        author
        developer
        link
      }
    }
  }
`;
